import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthService } from '@/services';
import { DialogDataModel } from './types';

@Component({
    selector: 'app-task',
    templateUrl: './task.component.html',
    styleUrls: ['./task.component.scss'],
    standalone: false
})
export class TaskComponent {
  teacher: boolean;

  constructor(
    public dialogRef: MatDialogRef<TaskComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogDataModel,
    private authService: AuthService
  ) {
    this.teacher = this.authService.isUserTeacher() || this.authService.isUserAdmin();
  }
}
